import cn from 'classnames/bind';
import { SEO } from 'ui';
import AboutUsSection from 'ui/layouts/AboutUsSection';
import SingleTypeLandingAbout from 'ui/layouts/SingleTypeLandingAbout/SingleTypeLandingAbout';
import SingleTypeLandingHeader from 'ui/layouts/SingleTypeLandingHeader/SingleTypeLandingHeader';
import { getSEOKeywords } from 'utils';
import { findByType, mapGroupToColor } from 'utils/personalities';
import { capitalize } from 'utils/string';

import FamousPersonsSection from '@/components/layouts/FamousPersonsSection';
import content from '@/content';

import s from './home/Home.module.scss';

const type = process.env.NEXT_PUBLIC_LANDING_TYPE || '';
const cx = cn.bind(s);
const pageContent = content[type];
const typePropOverrides = ({
  isfp: {
    defaultGender: 'other'
  },
  intj: {
    defaultGender: 'other'
  },
  'entj': {
    defaultGender: 'male' 
  },
  'istj': {
    defaultGender: 'other'
  }
})[type] || {}
const personalityType = {
  ...findByType(type),
  ...typePropOverrides
};

export default function Home({ seo }) {
  const longType = capitalize(personalityType.title);
  const color = mapGroupToColor[personalityType.group.title];
  const gender = personalityType.defaultGender;
  const group = personalityType.group.title;

  return (
    <div className={cx('home')}>
      {!!seo && (
        <SEO
          title={seo?.seo_title}
          description={seo?.meta_description}
          image={seo?.image}
          keywords={getSEOKeywords(seo)}
        />
      )}
      <SingleTypeLandingHeader
        type={type}
        longType={longType}
        gender={gender}
        color={color}
        group={group}
      />
      <SingleTypeLandingAbout
        type={type}
        advantages={pageContent.advantages}
        letters={pageContent.letters}
        disadvantages={pageContent.disadvantages}
        description={pageContent.aboutTypeDescription}
        content={pageContent.aboutTypeTextContent}
      />
      <FamousPersonsSection
        className={cx('famousSection')}
        type={longType}
        persons={pageContent.persons}
      />
      <AboutUsSection
        title="What is personalities profile about"
        text="The profile helps you to understand the values and motivations of your personality, how people perceive it, your strengths traits, and weaknesses. You will know about development and potential, employment, and the best career choices. The profile explores your personality leadership potential, romantic relationships, parenthood, and other aspects."
        cards={pageContent.aboutUsCards}
      />
    </div>
  );
}

export const getStaticProps = async () => {
  const { default: LandingModel } = await import('api/models/Landing');
  const data = await LandingModel.getByType(type);
  return {
    props: {
      seo: data.seo,
    },
  };
};
